// All persisted state lives under this prefix so we can bump the version
// if the shape of stored data ever changes in a breaking way.
const NAMESPACE = "webpreview";
const VERSION = "v1";

const key = (name) => `${NAMESPACE}:${VERSION}:${name}`;

export const STORAGE_KEYS = {
  THEME: key("theme"),
  HISTORY: key("history"),
  FAVORITE_DEVICE_IDS: key("favoriteDeviceIds"),
  CUSTOM_DEVICES: key("customDevices"),
  SESSIONS: key("sessions"),
  LAST_URL: key("lastUrl"),
  LAST_SELECTED_DEVICE_IDS: key("lastSelectedDeviceIds"),
  ORIENTATION_BY_DEVICE: key("orientationByDevice"),
  LAYOUT_MODE: key("layoutMode"),
  GLOBAL_ZOOM: key("globalZoom"),
};
